import {Component, ComponentFactoryResolver, OnDestroy, OnInit} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-treaty-cbc-reports-cell-component',
  templateUrl: './treaty-cbc-reports-cell-component.component.html',
  styleUrls: ['./treaty-cbc-reports-cell-component.component.scss']
})
export class TreatyCbcReportsCellComponentComponent implements OnInit, OnDestroy {
  item: any;
  fieldDefinition: FieldDefinition;
  unSubscribe$ = new Subject<void>();
  constructor(private dialogService: DialogService,
              private componentFactoryResolver: ComponentFactoryResolver) {
    console.log(this.fieldDefinition);
  }

  ngOnInit() {
    console.log(this.fieldDefinition);
  }
  openInfo() {
    const dialogModel: DialogModel = DialogModel.create(
      'Exchange of CbC Reports',
      'FootnoteDialogComponent',
      {data: 'data'}
    );
    dialogModel.cancelCaption = null;
    dialogModel.okCaption = 'Close';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(res => {
    });
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
